export enum BasketballLineupPositions {
  Player = 'player',
  Coach = 'coach',
}
